export const NODEMONKES_SLUG = 'nodemonkes'
export const FAVORITES_TRAIT = '__saved'
export const COLOR_TRAIT = '__color'
export type DiscoveryFilter = { trait_type: string; values: string[] }
export type MonkeCatalogItem = { number: number; id: string; colors: string[] }
export type MonkeCatalog = { version: number; generatedAt: string; items: MonkeCatalogItem[] }

export function readDiscoveryFilters(params: URLSearchParams): DiscoveryFilter[] {
	try {
		const parsed: unknown = JSON.parse(params.get('traits') || '[]')
		if (!Array.isArray(parsed)) return []
		return parsed.slice(0, 20).flatMap((f) =>
			f && typeof f.trait_type === 'string' && f.trait_type.length <= 80 && Array.isArray(f.values)
				? [{ trait_type: f.trait_type, values: f.values.filter((v: unknown): v is string => typeof v === 'string' && v.length <= 100).slice(0, 32) }]
				: []
		).filter((f) => f.values.length > 0)
	} catch { return [] }
}

export function monkeFilterUrl(filters: DiscoveryFilter[]) {
	const params = new URLSearchParams()
	if (filters.length) params.set('traits', JSON.stringify(filters))
	return `/collection/nodemonkes${params.size ? `?${params}` : ''}`
}

export function matchesDiscoveryFilters(id: string, filters: DiscoveryFilter[], saved: readonly string[], catalog: Map<string, MonkeCatalogItem>) {
	return filters.every((f) => {
		if (f.trait_type === FAVORITES_TRAIT) return saved.includes(id)
		if (f.trait_type === COLOR_TRAIT) return f.values.some((color) => catalog.get(id)?.colors.includes(color.replace('#', '').toLowerCase()))
		return true
	})
}

export function isDiscoveryFilter(type: string) {
	return type === COLOR_TRAIT || type === FAVORITES_TRAIT
}

export type TraitItem = { id: string; meta?: { attributes?: { trait_type: string; value: unknown }[] } }
export function relatedMonkes(current: TraitItem, items: TraitItem[], listed: Set<string>, limit = 6) {
	const traits = new Set((current.meta?.attributes || [])
		.filter((a) => a.trait_type !== 'Count' && String(a.value).toLowerCase() !== 'none')
		.map((a) => `${a.trait_type}:${a.value}`))
	return items.filter((i) => i.id !== current.id).map((item) => ({ item,
		matches: (item.meta?.attributes || []).filter((a) => traits.has(`${a.trait_type}:${a.value}`)).length
	})).filter((i) => i.matches > 0)
		.sort((a, b) => b.matches - a.matches || Number(listed.has(b.item.id)) - Number(listed.has(a.item.id)) || a.item.id.localeCompare(b.item.id))
		.slice(0, limit)
}
